import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { router } from "./router";
import { ApiError } from "./lib/api";
import "./styles.css";
import { registerSW } from "./lib/push";
import { startOutbox } from "./lib/offline";

void registerSW();

// Central Microsoft sign-in returns with ?token=… (the session cookie is already set): keep it out of history.
{
  const q = new URLSearchParams(window.location.search);
  if (q.has("token")) {
    q.delete("token");
    window.history.replaceState(null, "", `${window.location.pathname}${q.size ? `?${q}` : ""}${window.location.hash}`);
  }
}

const qc = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (n, err) => !(err instanceof ApiError && err.status < 500) && n < 2,
      refetchOnWindowFocus: false,
    },
  },
});

// Replay worker updates recorded offline; refresh what's on screen once they're in.
startOutbox(() => {
  void qc.invalidateQueries({ queryKey: ["item"] });
  void qc.invalidateQueries({ queryKey: ["items"] });
  void qc.invalidateQueries({ queryKey: ["my-day"] });
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={qc}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
